import { render, staticRenderFns } from "./div-navber-diy.vue?vue&type=template&id=73f88c5d&scoped=true"
import script from "./div-navber-diy.vue?vue&type=script&lang=js"
export * from "./div-navber-diy.vue?vue&type=script&lang=js"
import style0 from "./div-navber-diy.vue?vue&type=style&index=0&id=73f88c5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f88c5d",
  null
  
)

export default component.exports